import { useMutation, useQuery } from '@apollo/client';

import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  DeviceConfigHotWaterTemperature,
  GetHotWaterInformation,
  OverrideHotWater,
} from '../../../../../shared/api-clients/gql';
import { HotWaterSchedule } from '../../../components/schedules/hotWaterSchedule';
import { useHotWaterSchedules } from '../../../contexts/hotWaterSchedules';
import { WaterStatus } from './waterStatus';

interface IHotwaterViewProps {
  deviceId: string;
  temperatureData: DeviceConfigHotWaterTemperature;
  hasNoData: boolean;
}

export function HotWaterView({ deviceId, temperatureData, hasNoData }: IHotwaterViewProps) {
  const { hotWaterSchedules } = useHotWaterSchedules();

  const { data } = useQuery(GetHotWaterInformation, {
    variables: {
      deviceId,
    },
    nextFetchPolicy: 'network-only',
    pollInterval: 5000,
  });

  const [isBoosted, setIsBoosted] = useState(false);
  const [updateBoost] = useMutation(OverrideHotWater);

  useEffect(() => {
    if (!data) return;
    setIsBoosted(
      data?.getHotWaterInformation?.hot_water_active === 1 ??
        data?.getHotWaterInformation?.device_hot_water_active === 1
    );
  }, [data]);

  function updateBoostCall(status: boolean) {
    setIsBoosted(status);
    updateBoost({
      variables: {
        deviceId,
        status: status ? 'ON' : 'OFF',
      },
    });
  }

  return (
    <div data-qa="hotwater-details">
      <div className="p-8">
        <div className="w-1/3">
          <WaterStatus
            isScheduled={data?.getHotWaterInformation?.schedule_hot_water_active === 1}
            isBoosted={isBoosted}
            onToggle={updateBoostCall}
            setpoint={hasNoData ? undefined : temperatureData?.on}
            disabled={hasNoData}
          />
        </div>
      </div>
      <div className="p-8">
        <div className="flex flex-row flex-wrap">
          <HotWaterSchedule title={'Hot Water Schedules'} schedules={hotWaterSchedules} />
        </div>
      </div>
    </div>
  );
}
